type Props = {
  size?: number;
  color?: string;
  className?: string;
};

export const LikeIcon = ({
  size = 16,
  color = "currentColor",
  className,
}: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 46 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.3395 20.5738L20.8209 3.74072C22.309 3.74072 23.7362 4.33188 24.7885 5.38415C25.8407 6.43642 26.4319 7.86361 26.4319 9.35175V16.8331H37.018C37.5602 16.827 38.0973 16.9388 38.592 17.1608C39.0868 17.3829 39.5273 17.7098 39.8831 18.119C40.2389 18.5282 40.5015 19.0099 40.6527 19.5306C40.8039 20.0514 40.8401 20.5988 40.7587 21.1349L38.1776 37.968C38.0424 38.8599 37.5893 39.673 36.9019 40.2573C36.2145 40.8416 35.3391 41.1577 34.4369 41.1475H13.3395M13.3395 20.5738V41.1475M13.3395 20.5738H7.72847C6.73638 20.5738 5.78493 20.9679 5.08341 21.6694C4.3819 22.3709 3.98779 23.3224 3.98779 24.3145V37.4069C3.98779 38.399 4.3819 39.3504 5.08341 40.0519C5.78493 40.7534 6.73638 41.1475 7.72847 41.1475H13.3395"
        stroke={color}
        strokeWidth="3.74068"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
